import { callApi } from "modules/core/api/services";
import { BASE_URL } from "modules/core/constants";

export const createCheckoutSession = (
  eventUuid: string,
  productUuid: string,
  redirectBackPath: string = "/"
) => {
  const data = {
    product_uuid: productUuid,
    success_redirect_url: `${BASE_URL}/event/${eventUuid}/checkout?product=${productUuid}`,
    cancel_redirect_url: new URL(redirectBackPath, BASE_URL).toString()
  };

  return callApi("/v2/orders", "POST", data);
};

export const createProductCheckoutSession = (
  productUuid: string,
  redirectBackPath = "/"
) => {
  const data = {
    product_uuid: productUuid,
    success_redirect_url: `${BASE_URL}/checkout/success?productUuid=${productUuid}&redirectBack=${redirectBackPath}`,
    cancel_redirect_url: new URL(redirectBackPath, BASE_URL).toString()
  };
  return callApi("/v2/orders", "POST", data);
};
